module.exports = __webpack_public_path__ + "static/helps-launch-or-switch-career-eb8e106afbb13a74b3ba43074b6ed7f6.png";